import { render, staticRenderFns } from "./OtherChange.vue?vue&type=template&id=0eb5b506&scoped=true"
import script from "./OtherChange.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherChange.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OtherChange.vue?vue&type=style&index=0&id=0eb5b506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb5b506",
  null
  
)

export default component.exports